<ion-card class="card-common-blue ion-no-margin ion-margin-top">
  <!-- Card header with title and icon -->
  <ion-card-header>
    <ion-card-title>
      <div class="d-flex align-items-center gap-2">
        <ion-icon size="small" src="assets/imgs/calendar-icon-white.svg">
        </ion-icon>

        <span>
          {{ 'DETAILED_VEHICLE_INFO' | translate }}
        </span>
      </div>
    </ion-card-title>
  </ion-card-header>

  <!-- Card content -->
  <ion-card-content class="ion-padding ion-margin-top">
    <!-- Important vehicle dates section -->
    <div>
      <ion-row>
        <!-- MOT expiry date -->
        <ion-col size="12" [ngClass]="isMobileApp() ? 'd-flex justify-content-between' : ''">
          <span>
            {{ 'Vehicle_Details_Mot_Exp' | translate }} :
          </span>
          <span>
            {{
            vehicleInfo()
            ? (vehicleInfo()?.moT_EXPIRY | formatDate:isMobileApp()) || 'Unknown'
            : 'Unknown'
            }}
          </span>
        </ion-col>

        <!-- Road tax expiry date -->
        <ion-col size="12" [ngClass]="isMobileApp() ? 'd-flex justify-content-between' : ''">
          <span>
            {{ 'Vehicle_Rfl_Tax_Due' | translate }} :
          </span>
          <span>
            {{
            vehicleInfo()
            ? (vehicleInfo()?.rfL_EXPIRY | formatDate:isMobileApp()) || 'Unknown'
            : 'Unknown'
            }}
          </span>
        </ion-col>
      </ion-row>
    </div>
  </ion-card-content>
</ion-card>